module.exports = __webpack_public_path__ + "static/media/PrevDisabled-alt.2ebd907e.svg";